<template>
  <v-dropdown
    v-if="props.showTooltip"
    position="bottom"
    :max-width="180"
  >
    <template #activator>
      <a
        class="c-epg-indicators__upsell"
        :href="upsellUrl"
        target="_blank"
      >
        <img src="/static/images/go3.png">
      </a>
    </template>
    <template #default>
      {{ $t("product.upsell") }}
    </template>
  </v-dropdown>
  <a
    v-else
    class="c-epg-indicators__upsell"
    :href="upsellUrl"
    target="_blank"
  >
    <img src="/static/images/go3.png">
  </a>
</template>

<script setup>
  import { computed } from 'vue';
  import { useContext } from '@/shared/composables';
  import VDropdown from '@/index/shared/components/dropdown/index.vue';

  const props = defineProps({
    showTooltip: Boolean,
  });

  const { $services } = useContext();

  const info = $services.resolve('info');

  const upsellUrl = computed(() => `//${info.go3Host}?utm_medium=player-upsell&utm_source=tv3play`);
</script>
